import Modal from 'react-bootstrap/Modal'
import { useNavigate, useParams } from 'react-router-dom'
import posthog from 'posthog-js'

interface IModalProps {
    show: boolean
    onHide: () => void
    item: undefined | IMoneyPoolResults
    name: string | undefined
    isManager: boolean
    loanAmount?: number | undefined
    moneyPool?: string | undefined
    trustState?: string | undefined
    isLoan?: boolean
    selectedInstallment?: number | undefined
}
const PayToOtherModal = ({
    show,
    onHide,
    item,
    name,
    isManager,
    loanAmount,
    moneyPool,
    trustState,
    isLoan,
    selectedInstallment,
}: IModalProps) => {
    const navigate = useNavigate()
    const { id, loanId } = useParams()
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div className=" p-2 text-center">
                {isLoan ? (
                    <p>آیا مایل به پرداخت وام </p>
                ) : (
                    <p>آیا مایل به پرداخت حق عضویت</p>
                )}
                <p>
                    {item?.member.first_name} {item?.member.last_name}
                </p>
                <p>
                    به مبلغ{' '}
                    {loanAmount
                        ? loanAmount.toLocaleString()
                        : item?.unpaid_portion &&
                          item?.unpaid_portion.toLocaleString()}{' '}
                    تومان
                </p>
                <p>هستید؟</p>
                <hr className=" my-2" />
                <p
                    className=" text-green-1"
                    onClick={() => {
                        if (loanAmount && item) {
                            // The payment screen's OTHER door. The loan page
                            // fires this with the basket it built; this one
                            // sends the legacy single-installment shape, and
                            // its silence is why the «selected» count reads
                            // far below the «initiated» one.
                            posthog.capture(
                                'loan_installments_selected_for_payment',
                                {
                                    fund_id: moneyPool,
                                    loan_id: loanId,
                                    count: 1,
                                    entry: 'pay_to_other_modal',
                                }
                            )
                        }
                        loanAmount
                            ? item &&
                              navigate(
                                  `/easy-pay/pay-for-other-in-loan/${moneyPool}`,
                                  {
                                      state: {
                                          item: {
                                              id: item.id,
                                              unpaid_portion:
                                                  loanAmount ||
                                                  item.unpaid_portion,
                                          },
                                          name,
                                          isManager,
                                          trustState,
                                          selectedInstallment,
                                          loanId,
                                      },
                                  }
                              )
                            : navigate(`/easy-pay/pay-for-other/${id}`, {
                                  state: { item, name, isManager, trustState },
                              })
                        onHide()
                    }}
                >
                    تایید
                </p>
                <hr className=" my-2" />
                <p onClick={onHide}>بستن</p>
            </div>
        </Modal>
    )
}

export default PayToOtherModal
